import type { FC } from 'react';

import type { PublicTemporaryMessage } from '@api-client/temporary-messages';

import { useTemporaryMessageActions } from './useTemporaryMessageActions';
import { TemporaryMessage } from './TemporaryMessage';
import { trackTemporaryMessageClosed } from './TemporaryMessageTrackingService';

interface Props {
    displayedMessage: PublicTemporaryMessage;
    trigger: string | undefined;
}

export const TemporaryMessagesContainer: FC<Props> = ({ displayedMessage, trigger }) => {
    const { closeMessage } = useTemporaryMessageActions();

    const onMessageClose = (messageId: string): void => {
        trackTemporaryMessageClosed(displayedMessage, trigger);
        closeMessage(messageId);
    };

    if (!displayedMessage) {
        return null;
    }

    return (
        <TemporaryMessage
            message={displayedMessage}
            onMessageClose={onMessageClose}
            trigger={trigger}
        />
    );
};
